export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-end justify-center overflow-hidden pb-16 pt-32 md:pt-16">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/364fe5b2a8e07508df27c26cfd046a39.jpeg"
          alt="Gentle anxiety-friendly dental care at Beaulieu Dental Chelmsford"
          title="Compassionate dentist caring for anxious patient"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/60 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 md:mb-8 leading-tight px-2">
              Feel anxious or nervous about <span className="text-[#d0a24f]">dental treatment?</span> You're not alone.
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-4 md:mb-6 leading-relaxed max-w-3xl mx-auto px-4">
              At Beaulieu Dental in Chelmsford, we provide gentle, personalised dental care, delivered at a pace that's right for you, designed especially for nervous and trauma-experienced patients.
            </p>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 mb-4 md:mb-6 leading-relaxed max-w-3xl mx-auto px-4">
              Backed by real stories from real patients who overcame their dental anxiety with our support, our team is trusted for calm, compassionate, anxiety-friendly dentistry.
            </p>
            <p className="text-xl sm:text-2xl md:text-2xl lg:text-3xl text-white font-bold mb-6 md:mb-8 leading-relaxed max-w-3xl mx-auto px-4">
              Start with a free consultation and feel the difference for yourself.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
            <a
              href="https://beaulieudental.co.uk/book-free-consultation/"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-[#d0a24f] to-[#dcb964] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              Book Free Consultation
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </a>
            
            <a
              href="tel:01245465586"
              className="group inline-flex items-center gap-2 bg-white text-[#444c42] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            >
              <i className="ri-phone-line text-xl"></i>
              Request Call Back
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <a href="#features" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </a>
      </div>
    </section>
  );
}